import React from "react";
import "./index.css";
import TychosLogo from "./TychosLogo";

function App() {
  return (
    <div className="container">
      <TychosLogo />

      <div className="button-container">
        <a
          href="https://www.lulu.com/search?contributor=Simon+Shack"
          className="button buy-button"
          target="_blank"
          rel="noreferrer"
        >
          Buy the Book
        </a>
        <a
          href="https://forum.tychos.space"
          className="button forum-button"
          target="_blank"
          rel="noreferrer"
        >
          Visit the TYCHOS Forum
        </a>
        <a
          href="https://www.paypal.com/donate?hosted_button_id=QM24P8BHT4HJE"
          className="button donate-button"
          target="_blank"
          rel="noreferrer"
        >
          Donate
        </a>
      </div>

      <h1 />

      <div className="image-container">
        <div className="image-box">
          <a href="https://book.tychos.space" className="image-link" target="_blank" rel="noreferrer">
            <img
              src="/images/TychosBook.jpg"
              alt="Astronomy Book"
              className="image"
            />
          </a>
          <a
            href="https://book.tychos.space"
            className="button read-book-button"
            target="_blank"
            rel="noreferrer"
          >
            Read the Book Online
          </a>
        </div>

        <div className="image-box">
          <a href="https://ts.tychos.space" className="image-link" target="_blank" rel="noreferrer">
            <img
              src="/images/Tychosium.png"
              alt="Astronomy Program"
              className="image"
            />
          </a>
          <a
            href="https://ts.tychos.space"
            className="button explore-tychosium-button"
            target="_blank"
            rel="noreferrer"
          >
            Explore the Tychosium
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;